import { render, staticRenderFns } from "./methodPayment.vue?vue&type=template&id=47e6f1c5&"
import script from "./methodPayment.vue?vue&type=script&lang=js&"
export * from "./methodPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports